import React from 'react';
import { AutoHeightBody } from 'view/layout/styled';
import { BodyClassName } from 'view/common/body-class-name';
import { Header as DefaultHeader } from 'view/layout/header';
import type { PaperAppearance } from 'view/layout/paper';
import { Paper } from 'view/layout/paper';
import { EmptyHeader, Container, Banner, PaperContainer, SidebarPusherRoot, FlipperWithFlexbox } from './styled';
import { isAdvancedHelpCenter as isAdvancedHelpCenterUtil } from 'util/advanced-help-center';
import { isSearchEnhancementsMilestone1Enabled } from 'feature-flags';
import { SearchModal } from 'view/search-modal';

export interface Props {
    children: JSX.Element;
    isAnonymous?: boolean;
    headerless?: boolean;
    hideSearchButton?: boolean;
    helpCenterBanner: string | undefined;
    paperAppearance?: PaperAppearance;
    // Used as a key to determine whether or not we should add fade transitions between pages
    // we use the top level path from app.tsx to differentiate between different pages
    path: string | undefined;
    searchShown: boolean;
    fadeInSearchModal: boolean;
    hideBanner?: boolean;
}

/**
 * Paper in this context is the floating paper that is ontop of the banner.
 * Banner will have the background image chosen by the admin as well as the
 * theme color as background color.
 */
const BannerWithPaperLayoutDumb = ({
    children,
    paperAppearance,
    isAnonymous,
    headerless,
    hideSearchButton,
    helpCenterBanner,
    path,
    searchShown,
    fadeInSearchModal,
    hideBanner,
}: Props) => {
    // do not show banner on advanced help center
    const isAdvanceHelpCenter = isAdvancedHelpCenterUtil();

    return (
        <SidebarPusherRoot>
            <FlipperWithFlexbox flipKey={searchShown} portalKey="search">
                <Container>
                    <BodyClassName className="px-paper-layout" />

                    {!hideBanner && <Banner imageSrc={isAdvanceHelpCenter ? undefined : helpCenterBanner} />}

                    {!headerless && (
                        <DefaultHeader
                            isAnonymous={isAnonymous}
                            logoTextColor="banner"
                            hideSearchButton={hideSearchButton}
                            isAdvancedHelpCenter={isAdvanceHelpCenter}
                        />
                    )}
                    {headerless && <EmptyHeader />}

                    <PaperContainer>
                        <Paper appearance={paperAppearance} pageKey={path}>
                            {children}
                        </Paper>
                    </PaperContainer>

                    {/*
                SearchModal is included here and not in <App /> because if it is there are certain
                scenarios where the SearchModal would request data that the user isn't allowed and
                would make the entire /models request fail, resulting in a broken session.
            */}
                    {!isSearchEnhancementsMilestone1Enabled() && !isAnonymous && (
                        <SearchModal fadeSearchBarInOut={fadeInSearchModal} />
                    )}
                    <AutoHeightBody />
                </Container>
            </FlipperWithFlexbox>
        </SidebarPusherRoot>
    );
};

export default BannerWithPaperLayoutDumb;
